import React, { useEffect, useRef } from 'react';

const Accordion = props => {

	const accRef = useRef();

	useEffect(() => {
		_handleClick();
	}, [])

	const _handleClick = () => {
		const acc = accRef.current.children;

	  	for (let i = 0; i < acc.length; i++) {		  
			let a = acc[i];
			a.onclick = () => acc[0].classList.toggle("active");
			a.onclick = () => a.classList.toggle("active");
	  	}
	}

	return (
		<div ref={accRef} onClick={_handleClick}>
			{props.children}
		</div>
	)
}

export default Accordion;